import { _ServiceRequest } from '../../types/serviceRequest'
import {
    SET_SELECTED_SERVICE_REQUEST,
    SET_SERVICE_REQUEST_LIST,
    ServiceRequestActionTypes,
} from './types'

export interface ServiceRequestState {
    serviceRequestList?: _ServiceRequest[]
    serviceRequest?: _ServiceRequest
}

const initialState: ServiceRequestState = {}

export const serviceRequestReducer = (
    state = initialState,
    action: ServiceRequestActionTypes,
): ServiceRequestState => {
    switch (action.type) {
        case SET_SERVICE_REQUEST_LIST:
            return {
                ...state,
                serviceRequestList: action.serviceRequestList,
            }

        case SET_SELECTED_SERVICE_REQUEST:
            return {
                ...state,
                serviceRequest: action.serviceRequest,
            }

        default:
            return state
    }
}
